import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PSelectItem } from '../../../../../shared/design-system/atoms/p-select/p-select-item.model';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-terrain-form',
  templateUrl: './terrain-form.component.html',
  styleUrls: ['./terrain-form.component.scss'],
})
export class TerrainFormComponent implements OnChanges {
  @Input() terrain!: Report.Characteristics.Terrain | undefined;
  @Input() constructionYear!: number;

  @Output() terrainChanged = new EventEmitter<Report.Characteristics.Terrain>();

  @Output() constructionYearChanged = new EventEmitter<number>();

  terrainForm = new FormGroup({
    propertyType: new FormControl('Terrain', { nonNullable: true }),
    constructionYear: new FormControl('', [
      Validators.min(1000),
      Validators.max(9999),
      Validators.pattern(/^\d{4}$/),
    ]),
    areaM2: new FormControl(''),
    facadeWidthM2: new FormControl(''),
    plotRatio: new FormControl(''),
    accessibility: new FormControl(''),
  });

  viabilityItem!: PSelectItem;

  viabilityTypeItems: PSelectItem[] = [
    { value: null, label: '' },
    {
      value: 'non_buildable',
      label: 'Non viabilisable',
    },
    { value: 'buildable', label: 'Viabilisable' },
    {
      value: 'developed_with_utilities',
      label: 'Viabilisé',
    },
  ];

  terrainInternal!: Report.Characteristics.Terrain;
  constructionYearinternal!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['terrain'] && changes['terrain'].currentValue) {
      this.terrainInternal = changes['terrain'].currentValue;
    }

    if (
      changes['constructionYear'] &&
      changes['constructionYear'].currentValue
    ) {
      this.terrainForm.controls.constructionYear.setValue(
        this.constructionYear.toString(),
      );
    }

    this.setFormValues();
  }

  onConstructionYearChanged(event: Event) {
    this.constructionYearinternal = parseInt(
      (event.target as HTMLInputElement).value,
    );

    this.constructionYearChanged.emit(this.constructionYearinternal);
  }

  onAreaM2Changed(event: Event) {
    this.terrainInternal = {
      ...this.terrainInternal,
      areaM2: parseInt((event.target as HTMLInputElement).value),
    };

    this.terrainChanged.emit(this.terrainInternal);
  }

  onFacadeWidthM2Changed(event: Event) {
    this.terrainInternal = {
      ...this.terrainInternal,
      facadeWidthM2: parseInt((event.target as HTMLInputElement).value),
    };

    this.terrainChanged.emit(this.terrainInternal);
  }

  onPlotRatioChanged(event: Event) {
    this.terrainInternal = {
      ...this.terrainInternal,
      plotRatio: parseFloat((event.target as HTMLInputElement).value),
    };

    this.terrainChanged.emit(this.terrainInternal);
  }

  onAccessibilityChanged(event: Event) {
    this.terrainInternal = {
      ...this.terrainInternal,
      accessibility: (event.target as HTMLInputElement).value,
    };

    this.terrainChanged.emit(this.terrainInternal);
  }

  onViabilitySelected({ value }: PSelectItem): void {
    this.terrainInternal = {
      ...this.terrainInternal,
      viability: value ? value : null,
    };

    this.viabilityItem = { value };

    this.terrainChanged.emit(this.terrainInternal);
  }

  setFormValues(): void {
    this.terrainForm.controls.constructionYear.setValue(
      this.constructionYearinternal
        ? this.constructionYearinternal.toString()
        : '',
    );

    this.terrainForm.controls.areaM2.setValue(
      this.terrainInternal?.areaM2?.toString() || '',
    );

    this.terrainForm.controls.facadeWidthM2.setValue(
      this.terrainInternal?.facadeWidthM2?.toString() || '',
    );

    this.terrainForm.controls.plotRatio.setValue(
      this.terrainInternal?.plotRatio?.toString() || '',
    );

    this.terrainForm.controls.accessibility.setValue(
      this.terrainInternal?.accessibility || '',
    );

    this.viabilityItem = this.terrainInternal
      ? this.viabilityTypeItems.find(
          (item) => item.value === this.terrainInternal.viability,
        ) || this.viabilityTypeItems[0]
      : this.viabilityTypeItems[0];

    if (!this.terrainInternal.viability) {
      this.terrainInternal.viability = this.viabilityTypeItems[0]
        .value as string;
    }
  }
}
